<ws-button
	styleClass="button-primary"
	type="button"
	[disabled]="!hasActiveCriteria"
	(onClick)="clear()"
	matIcon="filter_list_off"
	text="_ws-framework.smart-table.clear-filters"
></ws-button>
